package ai.flowstorm.studio.ui.builder

import ai.flowstorm.common.setProperty
import ai.flowstorm.common.ui.EntityTable
import ai.flowstorm.studio.resources.space.BuildRequestResource
import io.kvision.core.Col
import io.kvision.core.Color
import io.kvision.html.Span
import io.kvision.i18n.I18n.tr
import io.kvision.modal.ModalSize
import io.kvision.tabulator.ColumnDefinition
import io.kvision.tabulator.Layout
import io.kvision.tabulator.TabulatorOptions
import io.kvision.utils.obj
import io.kvision.utils.px

class BuildRequestTable(
    splitMode: Boolean = true, hideHeader: Boolean = false, className: String? = "content-panel"
) : EntityTable<BuildRequest>(
    caption = "Build Request",
    model = BuildRequestResource,
    tabulatorOptions = TabulatorOptions(
        layout = Layout.FITCOLUMNS,
        columns = listOf(
            ColumnDefinition(tr("Name"), BuildRequest::name.name, width = "55%"),
            ColumnDefinition(tr("State"), BuildRequest::state.name, width = "30%"),
            ColumnDefinition(tr("Stats"), BuildRequest::stats.name, width = "15%"),
//            ColumnDefinition(tr("Stats"), BuildRequest::stats.name, width = "15%", formatterComponentFunction = { _, _, data: BuildRequest ->
//                console.log(data)
//                Span("AAA")
//
////                Span().apply {
////                    add(Span(data.stats.built.toString()).apply { color = Color.name(Col.GREEN) })
////                    + "/"
////                    add(Span(data.stats.failed.toString()).apply { color = Color.name(Col.RED) })
////                    + "/"
////                    add(Span(data.stats.notStarted.toString()).apply{ color = Color.name(Col.BLACK) })
////                }
//
//            }),
        ),
    ),
    entityComponentFactory = { BuildRequestEditor(BuildRequestResource) },
    entityFactory = { BuildRequest() },
    tabWidth = 450.px,
    splitMode = splitMode,
    seekEnabled = true,
    searchEnabled = true,
    modalSize = ModalSize.XLARGE,
    hideHeader = hideHeader,
    className = className,
    dataExtractor = {
        obj {
            setProperty(this, it::name)
            setProperty(this, it::state)
            setProperty(this, it::stats)
        }
    },
)
